import { actionConstants } from '../actions/actionConstants';

const initState = {
  isFetching: false,
  currentUserPermissions: null, //[]
  permissions: {},
  errors: '',
};

export default (state = initState, action) => {
  switch (action.type) {
    case actionConstants.GET_CURRENT_USER_PERMISSIONS_SUCCESS:
      return { ...state, currentUserPermissions: action.data };
    case actionConstants.GET_CURRENT_USER_PERMISSIONS_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.GET_PERMISSIONS_SUCCESS:
      return { ...state, permissions: action.data };
    case actionConstants.GET_PERMISSIONS_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.GET_PERMISSIONS_BY_ROLE_SUCCESS:
      return { ...state, permissions: action.data };
    case actionConstants.GET_PERMISSIONS_BY_ROLE_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.UPDATE_PERMISSIONS_SUCCESS:
      return { ...state };
    case actionConstants.UPDATE_PERMISSIONS_FAILURE:
      return { ...state, errors: action.data };
    default:
      return state;
  }
};
